import { render, staticRenderFns } from "./CompanyContacts.vue?vue&type=template&id=65f0f912&"
import script from "./CompanyContacts.vue?vue&type=script&lang=js&"
export * from "./CompanyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports